import React from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { TEMPLATES } from "@/constants/testIds";

const kb = (n) => `${(n / 1024).toFixed(1)} KB`;
const shortSrc = (s) => (s.length > 48 ? `${s.slice(0, 45)}…` : s);

export function CidAnalysisResult({ analysis }) {
  const { images, failures, total_bytes: total } = analysis;
  return (
    <div className="space-y-2" data-testid={TEMPLATES.cidAnalysisResult}>
      <div className="text-[11px] text-slate-600" data-testid="cid-analysis-summary">
        <strong className="text-slate-900">{images.length}</strong> imagen(es) embebidas · {kb(total)}
        {failures.length > 0 && <span className="text-amber-700"> · {failures.length} se mantendrán externas</span>}
      </div>
      <ul className="space-y-1">
        {images.map((img) => (
          <li key={img.cid} className="flex items-center gap-2 text-[11px] text-slate-600"
            data-testid={`cid-image-${img.cid}`}>
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 flex-shrink-0" strokeWidth={1.75} />
            <span className="font-mono truncate" title={img.source}>{shortSrc(img.source)}</span>
            <span className="ml-auto text-slate-400 whitespace-nowrap">
              {img.converted_from_svg ? "SVG→PNG · " : ""}{kb(img.size)}
            </span>
          </li>
        ))}
        {failures.map((f) => (
          <li key={f.source} className="flex items-center gap-2 text-[11px] text-amber-800"
            data-testid="cid-image-failure">
            <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={1.75} />
            <span className="font-mono truncate" title={f.source}>{shortSrc(f.source)}</span>
            <span className="ml-auto whitespace-nowrap">{f.reason}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
